module.exports = __webpack_public_path__ + "img/tscgicon.c1809a03.svg";